
<template>
   <div class="Homecontainer">
    <my-header></my-header> 
    <!-- 返回顶部 -->
    <div class="backTop hide"  data-menuanchor="page1">
      <a href="#page1" style="width: 100%;height: 100%;display: inline-block;">
       <img src="../assets/img/fanhuidingbu.png">
      </a>
    </div>
    <!-- 内容 -->
    <full-page :options="options">
      <!-- 合作伙伴 -->
      <div class="section section4">
        <div class="box4">
          <div class="fourth-floor">
            <p class="title">合作伙伴</p>
            <div class="fourth-content"> 
              <div class="Onecontent" style="displsy:flex">
                <div>
                  <img src="../assets/img/beiqi.png" style=" position: relative;top:30%;left:21%;width:55%">
                </div>
                <div>
                   <img src="../assets/img/futian.png" style="position: relative;top:25%;left:25%;width:50%">
                </div>
                <div>
                  <img src="../assets/img/yutong.png" style="position: relative;top:35%;left:23%;width:55%">
                </div>
                <div>
                  <img src="../assets/img/qirui.png" style="position: relative;top:40%;left:17%;width:65%">
                </div>
                <div>
                  <img src="../assets/img/biyadi.png" style="position: relative;top:32%;left:20%;width:60%">
                </div>
              </div>
              <div class="Twocontent" style="display:flex" >
                <div>
                  <img src="../assets/img/guangqi.png" style="position: relative;top:29%;left:19%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/richan.png" style="position: relative;top:23%;left:21%;width:55%">
                </div>
                <div>
                  <img src="../assets/img/zhongtong.png" style="position: relative;top:27%;left:27%;width:45%">
                </div>
                <div>
                   <img src="../assets/img/changcheng.png" style="position: relative;top:27%;left:20%;width:60%">
                </div>
              </div>
              <div class="Threecontent" style="display:flex">
                <div>
                  <img src="../assets/img/yiqi.png" style="position: relative;top:30%;left:20%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/xiandai.png" style="position: relative;top:33%;left:20%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/haige.png" style="position: relative;top:32%;left:19%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/jianghuai.png" style="position: relative;top:40%;left:18%;width:65%">
                </div>
                <div>
                  <img src="../assets/img/lingpao.png" style="position: relative;top:23%;left:30%;width:40%">
                </div>
              </div>
            </div>
          </div>
          <div class="fourth-bottom" data-menuanchor="page5">
            <a href="#page5" style="width: 100%;height: 100%;display: inline-block;">
              <img src="../assets/img/icon3.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <!-- <my-footer></my-footer>  -->
    </full-page>
  </div>
</template>
<script>
  import Vue from 'vue';
  import axios from 'axios';
  import myHeader from '@/components/Header.vue'
  import myFooter from '@/components/Footer.vue'
  import { Carousel} from 'element-ui';
  Vue.use(Carousel)
  export default {
    data() {
      return {
        homeNews:{},
        example0:"",
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          afterLoad: this.afterLoad,
          anchors: ['page1', 'page2', 'page3', 'page4','page5'],
          scrollBar: false,
          menu: "#menu",
        }
      }
    },
    mounted() {
    },
    components:{
      myHeader,
      myFooter,
    },
    methods: {
      moreNews(){
        this.$router.push('./news?id=8&page=1')
      },
      goNewsdetail(id){
        this.$router.push(`./newsDetail?id=${id}`)
      },
      enterAnimate(event){
        event.currentTarget.className = "animated  headShake"
      },
      leaveAnimate(event){
        event.currentTarget.className = ""
      }
    },
    watch:{
      // 鼠标滑动时顶部导航加背景，返回顶部按钮显示，
      $route(to, from) {
        if(window.location.href.split("#")[1]=="page1"){
          setTimeout(
            function(){
              $('.backTop').addClass('hide')
            },500)
        }else{
          $('.backTop').removeClass("hide") 
        }
      }
    }
  }
</script>
<style scoped lang = 'scss'>
  @import '@/lib/reset.scss';
  .Homecontainer{
    /* 返回顶部 */
    .backTop{
      position: fixed;
      right:2%;
      bottom:3%;
      z-index:2;
    }
    .backTop img{
      width:50px;
    }
    /*合作伙伴动画*/
    .fourth-floor .title{opacity: 0;transition: all 1s;margin-top:-10%;}
    .active .fourth-floor .title{margin-top: 0px;opacity: 1;transition-delay:0.5s;}
    .ltie10 .fourth-floor .title{margin-top: 0px;opacity: 1;transition-delay:0.5s;}
    .fourth-floor .fourth-content{opacity:0;transition: all 1s;margin-top:20%;}
    .active .fourth-floor .fourth-content{margin-top: 0px;opacity:1;transition-delay: 0.6s;}
    .ltie10 .fourth-floor .fourth-content{margin-top: 0px;opacity:1;transition-delay:0.6s;}
  
    .hide{display: none}
    .contauner-fliud{
      width:100%;
      height: 100%;
    }
    .section{
      position: relative;
    } 
     .second-content .title::before, .third-floor .title::before,.fourth-floor .title::before{
      content: "——"
    }
    .second-content .title, .third-floor .title,.fourth-floor .title{
      font-size: 65px;
      color:#004098;
      text-align: center;
      margin-bottom: 2%;
    }
    .second-content .title::after,.third-floor .title::after,.fourth-floor .title::after{
      content: "——"
    }

    /*所以页的底部箭头 */
    .first-bottom,.second-bottom,.third-bottom,.fourth-bottom{
      position:absolute;
      bottom:2%;
      left: 45%;   
      z-index:2;
      text-align: center;
      display: table-cell; 
      vertical-align: middle ;
    }
    .first-bottom p{
      color: #fff;
    }
    .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
      margin-top:8px;
      width:80% ;
      animation: bounce-down 1s linear infinite;
    }
    @keyframes bounce-down{
      25% {transform:translateY(-4px);}
      50% {transition: translateY(0);}
      75% {transform: translateY(4px);}
      100% {transform:translateY(0);}
    }
   
    /* 合作伙伴 */
    .section4{
      width: 100%;
      background-image: url('../assets/img/dabeijing4.png');
      background-size:100% 100%;
    }
    .fourth-floor{
      position: absolute;
      top:16%;
      z-index:1;
      margin:0 15%;
    }
    .fourth-content{
      width:1281px;
      height: 520px;
      background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
      background-size:100% 100%;
      padding:4% 0;
    }
    .Onecontent,.Twocontent,.Threecontent{
      display: flex;
      justify-content: center;
    }
    .Twocontent,.Threecontent{
      margin-top: -7%;
    }
    .Onecontent div,.Twocontent div,.Threecontent div{
      width:16%;
      height:200px;
       background: url('../assets/img/logobaisebeijing.png') no-repeat;
      background-size: 100% 100%;
    }
    .Onecontent img,.Twocontent img,.Threecontent img{
        transition:1s linear
    }
    .Onecontent div:hover{
      cursor: pointer;
    }
    .Onecontent img:hover,.Twocontent img:hover,.Threecontent img:hover{
      transform: scale(1.1)
    }
    @media screen and (max-width:1680px) and (min-width:1440px){
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:20%;
        z-index:1;
        margin:0 23%;
      }
      .fourth-content{
        width:940px;
        height:400px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:150px;
      }
    }
    @media screen and (max-width:1440px) and (min-width:1366px){
      .second-content .title, .third-floor .title,.fourth-floor .title{
        font-size:55px;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:20%;
        z-index:1;
        margin:0 20%;
      }
      .fourth-content{
        width:900px;
        height:370px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:145px;
      }
    }
    @media screen and (max-width:1366px) and (min-width:1280px){
      .second-content .title, .third-floor .title,.fourth-floor .title{
        font-size: 52px;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:15%;
        z-index:1;
        margin:0 22%;
      }
      .fourth-content{
        width:800px;
        height:300px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
        padding:3% 0;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:122px;
      }
    }
    @media screen and (max-width:1280px) and (min-width:1024px){
      .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
        margin-top:5px;
        width:50% ;
      }
      .second-content .title, .third-floor .title,.fourth-floor .title{
        font-size: 50px;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:15%;
        z-index:1;
        margin:0 22%;
      }
      .fourth-content{
        width:800px;
        height:300px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
        padding:2% 0;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:125px;
      }
    }
    @media screen and (max-width:1024px)and (min-width:650px){
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:15%;
        z-index:1;
        margin:0 10%;
      }
      .fourth-content{
        width:800px;
        height:300px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:120px;
      }
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/text.vue